var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countries-list"},[_c('page-header',{attrs:{"header":"Countries"}}),_c('div',{staticClass:"mt-3"},[_c('search',{staticClass:"mb-3",on:{"input":_vm.updateSearchParam}}),_c('vue-good-table',{attrs:{"styleClass":"vgt-table","columns":_vm.columns,"rows":_vm.countries},on:{"on-row-click":function (ref) {
	var row = ref.row;

	return _vm.onRowClick(row);
}}}),_c('pagination',{attrs:{"data":_vm.pagination,"disabled":_vm.loading},on:{"change-page":_vm.changePage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }